var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlineTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3483_33799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2734 3.5H13.5234V2C13.5234 1.60218 13.3654 1.22064 13.0841 0.93934C12.8028 0.658035 12.4213 0.5 12.0234 0.5H7.52344C7.12561 0.5 6.74408 0.658035 6.46278 0.93934C6.18147 1.22064 6.02344 1.60218 6.02344 2V3.5H2.27344V5H3.77344V16.25C3.77344 16.8467 4.01049 17.419 4.43245 17.841C4.8544 18.2629 5.4267 18.5 6.02344 18.5H13.5234C14.1202 18.5 14.6925 18.2629 15.1144 17.841C15.5364 17.419 15.7734 16.8467 15.7734 16.25V5H17.2734V3.5ZM7.52344 2H12.0234V3.5H7.52344V2ZM14.2734 16.25C14.2734 16.4489 14.1944 16.6397 14.0538 16.7803C13.9131 16.921 13.7223 17 13.5234 17H6.02344C5.82452 17 5.63376 16.921 5.49311 16.7803C5.35246 16.6397 5.27344 16.4489 5.27344 16.25V5H14.2734V16.25Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02343 8H7.52344V14H9.02343V8Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0234 8H10.5234V14H12.0234V8Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3483_33799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.773438 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineTrash);
export default __webpack_public_path__ + "static/media/outlineTrash.d1cb7f07b619d004301fe337732e1897.svg";
export { ForwardRef as ReactComponent };